import { useQuery } from "@tanstack/react-query";
import { getAllRestorants } from "../../../store/Settings/api";

export const useGetAllRestorants = () => {
    return useQuery(["Restaurants"], getAllRestorants);
};
